import { ServerConfig } from "@/config/config";
import { GeneralPriceRule } from "@/models/base/general-price-rule";
import { Axios } from "@/utils/axios";
import { AuthService } from ".";
import { MODULE } from "@/config/modules";

class GeneralPriceRuleServiceClass {
	readonly url:string = `${ServerConfig.host}/general-price-rules`;
	private fetchedRules:GeneralPriceRule[] | null = null;

	public async fetchPriceRules():Promise<GeneralPriceRule[]>{
		if (!AuthService.hasModule(MODULE.PRIJSBEDING)) {
			this.fetchedRules = [];
			return [];
		}
		let result = await Axios.get(this.url);
		this.fetchedRules = ((result.data || []) as any[]).map(r=>new GeneralPriceRule(r)).sort((a,b)=>a.DisplayOrder-b.DisplayOrder);;
		return this.fetchedRules;
	}

	public async getPriceRules():Promise<GeneralPriceRule[]>{
		if (this.fetchedRules === null) {
			return this.fetchPriceRules();
		}
		return this.fetchedRules;
	}

	public async createPriceRule(rule:GeneralPriceRule):Promise<GeneralPriceRule>{
		let result = await Axios.post(this.url, rule.getJSON());
		return new GeneralPriceRule(result.data);
	}

	public async updatePriceRule(rule:GeneralPriceRule):Promise<GeneralPriceRule>{
		let result = await Axios.put(`${this.url}/${rule.ID}`, rule.getJSON());
		return new GeneralPriceRule(result.data);
	}

	public async deletePriceRule(rule:GeneralPriceRule):Promise<void>{
		await Axios.delete(`${this.url}/${rule.ID}`);
	}

	public async setOrder(rules:GeneralPriceRule[]):Promise<void>{
		await Axios.post(`${this.url}/set-order`, rules.map(r=>r.ID));
	}
}

export const GeneralPriceRuleService = new GeneralPriceRuleServiceClass();